import React from "react";
import { connect } from "react-redux";
import { SketchPicker } from "react-color";
import {
    Row,
    Col,
    Label,
    CardBody
} from "reactstrap";
import { units } from "../../../../../../common/units";
import { templateActions } from "../../../../../../store/actions/cms/template/template.action";
import { DropDownFacade } from "../../../../../../components/UI/Buttons/DropDownFacade";
import ColorPickerFacade from "../../../../../../components/UI/Buttons/ColorPickerFacade";
import SystemLabel from "../../../../../../system/SystemLabel/SystemLabel";
import Slider, { createSliderWithTooltip } from "rc-slider";
import JirangoFontPicker from "../../../../../../fonts/FontPicker";
import { deepClone, setValueToNestedObject } from "../../../../../../helpers/objectHelper";
import { templateHelper } from "../../../helpers/templateHelper";
import EditorSlider from "../../../../../components/editor/tools/EditorSlider";
import { FontWeightPicker } from "../../../../../../fonts/FontWeightPicker/FontWeightPicker";
import { UrlMultiInput } from "../../../../../components/editor/tools/UrlMultiInput/UrlMultiInput";
import ListExpansion from "../../../../../../components/UI/ListExpansion/ListExpansion";


class AgendaSettings extends React.Component {
    handleUpdate = template => {
        const { dispatch } = this.props;
        dispatch(templateActions.softUpdate(template));
    };
    handleUnitChange = (unit, path) => {
        const { template } = this.props;
        const names = path.split(".");
        let templateCopy = deepClone(template);
        const cu = templateHelper.nestledFind(path, templateCopy.content)
        let val = parseInt(cu)
        templateCopy.content = deepClone(
            setValueToNestedObject(names, val + unit, templateCopy.content)
        );
        this.handleUpdate(templateCopy);
    };
    setBackgroundImage = url => {
        const { template } = this.props;
        const templateCopy = deepClone(template);
        templateCopy.content.interaction.agenda.content.background = `url('${url}')  no-repeat center center / cover`;
        templateCopy.content.interaction.agenda.content.backgroundSize = `cover`;
        templateCopy.content.interaction.agenda.content.backgroundUrl = url;
        this.handleUpdate(templateCopy);
    };
    /*  handleSpaceOnChange = (e, path, dir) => {
         const names = path.split(".");
         const element = deepClone(this.props.selectedElement);
         const spaceValue = element[names[0]][names[1]];
         let value = e.target.value;
         let splitted = spaceValue.toString().split(' ')
         if (splitted.length > 1) {
             splitted[dir] = value + 'px';
             splitted = splitted.join(' ')
             element[names[0]][names[1]] = splitted;
         }
         else {
             let newString = `${splitted[0]}px ${splitted[0]}px ${splitted[0]}px ${splitted[0]}px`;
             newString = newString.split(' ');
             newString[dir] = value + 'px';
 
             element[names[0]][names[1]] = newString.join(' ');
         }
         this.handleSoftUpdate(element);
     }
     convertSpaceValue = (value, index) => {
         let splitted = value.toString().split(' ')
         if (splitted.length > 1) {
             return parseInt(splitted[index]);
         }
         else {
             return parseInt(splitted[0]);
         }
     } */
    handleChange = (color, e, path, fallbackUnit = null) => {
        const { template } = this.props;
        const names = path.split(".");
        let templateCopy = deepClone(template);
        let value = templateHelper.getValueFromInput(e, color);
        let unit = templateHelper.getUnit(templateCopy, names);
        if (parseFloat(value) && unit.length < 4) {
            value += unit;
        }
        templateCopy.content = deepClone(
            setValueToNestedObject(names, value, templateCopy.content)
        );
        if (path == 'interaction.agenda.content.backgroundColor') {
            templateCopy.content.interaction.agenda.content.background = templateHelper.parseColorToRgba(color);
        }
        this.handleUpdate(templateCopy);
    };
    render() {
        const { template } = this.props;
        if (template === undefined || template.content.interaction.connections === undefined) return null;
        return (
            <div style={{ paddingTop: "10px", margin: '0px -10px' }}>
                <ListExpansion
                    footer={false}
                    description="Frame"
                >
                    <div style={{ paddingTop: "10px" }}>

                        <Row>
                            <Col className="list-setting-item-title">
                                <Label>
                                    <SystemLabel name="OuterFrameBackgroundColor" />
                                </Label>
                            </Col>
                            <Col className="list-setting-item-input">
                                <ColorPickerFacade
                                    color={template.content.interaction.agenda.content.backgroundColor}
                                    onChange={(color, e) =>
                                        this.handleChange(color, e, "interaction.agenda.content.backgroundColor")
                                    }
                                    path="interaction.agenda.content.backgroundColor"
                                />
                            </Col>
                        </Row>
                        <hr />
                        <Row>
                            <Col className="list-setting-item-title">
                                <Label>
                                    <SystemLabel name="BackgroundImage" />
                                </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="list-setting-item-title">
                                {template && template.content.interaction.agenda.content.backgroundUrl && (
                                    <img
                                        style={{ cursor: "pointer", width: "120px", marginTop: "5px" }}
                                        onClick={() =>
                                            this.setBackgroundImage(template.content.interaction.agenda.content.backgroundUrl
                                            )
                                        }
                                        alt=""
                                        src={template.content.interaction.agenda.content.backgroundUrl}
                                    />
                                )}
                            </Col>
                        </Row>
                        <UrlMultiInput onChange={this.setBackgroundImage} setImage={this.setBackgroundImage} url={template.content.interaction.agenda.content.backgroundUrl} />
                        <hr />
                        <EditorSlider
                            value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.content.padding")}
                            defaultValue={0}
                            unitChange={this.handleUnitChange}
                            onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                            units={["px", "rem", "%"]}
                            activeUnit={templateHelper.getUnit(template, "interaction.agenda.content.padding")}
                            steps={1}
                            max={100}
                            min={1}
                            path={"interaction.agenda.content.padding"}
                            label="OuterFramePadding"
                        />
                        <hr />
                        <EditorSlider
                            value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.content.margin")}
                            defaultValue={0}
                            unitChange={this.handleUnitChange}
                            onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                            units={["px", "rem", "%"]}
                            activeUnit={templateHelper.getUnit(template, "interaction.agenda.content.margin")}
                            steps={1}
                            max={100}
                            min={1}
                            path={"interaction.agenda.content.margin"}
                            label="OuterFrameMargin"
                        />
                        <hr />
                        <EditorSlider
                            value={templateHelper.getValueWithoutUnit(
                                template,
                                "interaction.agenda.content.borderRadius"
                            )}
                            defaultValue={0}
                            unitChange={this.handleUnitChange}
                            onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                            units={["px", "rem", "%"]}
                            activeUnit={templateHelper.getUnit(template, "interaction.agenda.content.borderRadius")}
                            steps={1}
                            max={100}
                            min={1}
                            path={"interaction.agenda.content.borderRadius"}
                            label="OuterFrameBorderRadius"
                        />

                    </div>
                </ListExpansion>
                <br />
                <ListExpansion
                    footer={false}
                    description="Title"
                >
                    <div style={{ paddingTop: "10px" }}>
                        <Row>
                            <Col><SystemLabel name="TitleColor" /></Col>
                            <Col className="list-setting-item-input">
                                <ColorPickerFacade
                                    color={template.content.interaction.agenda.title.color}
                                    onChange={(color, e) =>
                                        this.handleChange(color, e, "interaction.agenda.title.color")
                                    }
                                    path="interaction.agenda.title.color"
                                />
                            </Col>
                        </Row>
                        <JirangoFontPicker
                            onChange={this.handleChange}
                            path="interaction.client.agenda.title.fontFamily"
                            currentFontFamily={
                                template && template.content.interaction.agenda.title.fontFamily
                            }
                        />
                        <FontWeightPicker
                            onChange={this.handleChange}
                            path="interaction.client.agenda.title.fontWeight"
                            currentFont={template.content.interaction.agenda.title.fontFamily}
                            weight={template.content.interaction.agenda.title.fontWeight}
                        />
                        <hr />
                        <EditorSlider
                            value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.title.marginLeft")}
                            defaultValue={0}
                            unitChange={this.handleUnitChange}
                            onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                            units={["px", "rem", "%"]}
                            activeUnit={templateHelper.getUnit(template, "interaction.agenda.title.marginLeft")}
                            steps={1}
                            max={100}
                            min={1}
                            path={"interaction.agenda.title.marginLeft"}
                            label="MarginLeft"
                        />
                        <EditorSlider
                            value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.title.fontSize")}
                            defaultValue={0}
                            unitChange={this.handleUnitChange}
                            onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                            units={["px", "rem", "%"]}
                            activeUnit={templateHelper.getUnit(template, "interaction.agenda.title.fontSize")}
                            steps={1}
                            max={100}
                            min={1}
                            path={"interaction.agenda.title.fontSize"}
                            label="TitleFontSize"
                        />
                    </div>
                </ListExpansion>
                <br />
                <ListExpansion
                    footer={false}
                    description="DefaultRowStyle"
                >
                    <div style={{ paddingTop: "10px" }}>
                        <ListExpansion
                            footer={false}
                            description="FrameStyle"
                        >
                            <div style={{ paddingTop: "10px" }}>
                                <Row>
                                    <Col><SystemLabel name="FrameBackgroundColor" /></Col>
                                    <Col className="list-setting-item-input">
                                        <ColorPickerFacade
                                            color={template.content.interaction.agenda.row.default.frame.backgroundColor}
                                            onChange={(color, e) =>
                                                this.handleChange(color, e, "interaction.agenda.row.default.frame.backgroundColor")
                                            }
                                            path="interaction.agenda.row.default.frame.backgroundColor"
                                        />
                                    </Col>
                                </Row>
                                <hr />
                                <Row>
                                    <Col><SystemLabel name="FrameBorderColor" /></Col>
                                    <Col className="list-setting-item-input">
                                        <ColorPickerFacade
                                            color={template.content.interaction.agenda.row.default.frame.borderColor}
                                            onChange={(color, e) =>
                                                this.handleChange(color, e, "interaction.agenda.row.default.frame.borderColor")
                                            }
                                            path="interaction.agenda.row.default.frame.borderColor"
                                        />
                                    </Col>
                                </Row>
                                <hr />
                                <EditorSlider
                                    value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.row.default.frame.borderWidth")}
                                    defaultValue={0}
                                    unitChange={this.handleUnitChange}
                                    onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                                    units={["px", "rem", "%"]}
                                    activeUnit={templateHelper.getUnit(template, "interaction.agenda.row.default.frame.borderWidth")}
                                    steps={1}
                                    max={100}
                                    min={1}
                                    path={"interaction.agenda.row.default.frame.borderWidth"}
                                    label="FrameBorderWidth"
                                />
                                <hr/>
                                  <EditorSlider
                                    value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.row.default.frame.borderRadius")}
                                    defaultValue={0}
                                    unitChange={this.handleUnitChange}
                                    onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                                    units={["px", "rem", "%"]}
                                    activeUnit={templateHelper.getUnit(template, "interaction.agenda.row.default.frame.borderRadius")}
                                    steps={1}
                                    max={100}
                                    min={1}
                                    path={"interaction.agenda.row.default.frame.borderRadius"}
                                    label="FrameBorderRadius"
                                />
                                <hr />
                                <EditorSlider
                                    value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.row.default.frame.padding")}
                                    defaultValue={0}
                                    unitChange={this.handleUnitChange}
                                    onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                                    units={["px", "rem", "%"]}
                                    activeUnit={templateHelper.getUnit(template, "interaction.agenda.row.default.frame.padding")}
                                    steps={1}
                                    max={100}
                                    min={1}
                                    path={"interaction.agenda.row.default.frame.padding"}
                                    label="FramePadding"
                                />
                                <hr/>
                                 <EditorSlider
                                    value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.row.default.frame.marginTop")}
                                    defaultValue={0}
                                    unitChange={this.handleUnitChange}
                                    onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                                    units={["px", "rem", "%"]}
                                    activeUnit={templateHelper.getUnit(template, "interaction.agenda.row.default.frame.marginTop")}
                                    steps={1}
                                    max={100}
                                    min={1}
                                    path={"interaction.agenda.row.default.frame.marginTop"}
                                    label="FrameMarginTop"
                                />
                            </div>
                        </ListExpansion>
                        <hr />
                        <ListExpansion
                            footer={false}
                            description="TitleStyle"
                        >
                          <div style={{ paddingTop: "10px" }}>
                                <Row>
                                    <Col><SystemLabel name="TitleColor" /></Col>
                                    <Col className="list-setting-item-input">
                                        <ColorPickerFacade
                                            color={template.content.interaction.agenda.row.default.title.color}
                                            onChange={(color, e) =>
                                                this.handleChange(color, e, "interaction.agenda.row.default.title.color")
                                            }
                                            path="interaction.agenda.row.default.title.color"
                                        />
                                    </Col>
                                </Row>
                                <hr />
                                <EditorSlider
                                    value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.row.default.title.fontSize")}
                                    defaultValue={0}
                                    unitChange={this.handleUnitChange}
                                    onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                                    units={["px", "rem", "%"]}
                                    activeUnit={templateHelper.getUnit(template, "interaction.agenda.row.default.title.fontSize")}
                                    steps={1}
                                    max={100}
                                    min={1}
                                    path={"interaction.agenda.row.default.row.default.title.fontSize"}
                                    label="TitleFontSize"
                                />
                                <hr/>
                                <JirangoFontPicker
                                    onChange={this.handleChange}
                                    path="interaction.client.agenda.row.default.title.fontFamily"
                                    currentFontFamily={
                                        template && template.content.interaction.agenda.row.default.title.fontFamily
                                    }
                                />
                                <FontWeightPicker
                                    onChange={this.handleChange}
                                    path="interaction.client.agenda.row.default.title.fontWeight"
                                    currentFont={template.content.interaction.agenda.row.default.title.fontFamily}
                                    weight={template.content.interaction.agenda.row.default.title.fontWeight}
                                />
                            </div>
                        </ListExpansion>
                        <hr />
                        <ListExpansion
                            footer={false}
                            description="TextStyle"
                        >
                            <div style={{ paddingTop: "10px" }}>
                                <Row>
                                    <Col><SystemLabel name="TextColor" /></Col>
                                    <Col className="list-setting-item-input">
                                        <ColorPickerFacade
                                            color={template.content.interaction.agenda.row.default.text.color}
                                            onChange={(color, e) =>
                                                this.handleChange(color, e, "interaction.agenda.row.default.text.color")
                                            }
                                            path="interaction.agenda.row.default.text.color"
                                        />
                                    </Col>
                                </Row>
                                <hr />
                                <EditorSlider
                                    value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.row.default.text.fontSize")}
                                    defaultValue={0}
                                    unitChange={this.handleUnitChange}
                                    onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                                    units={["px", "rem", "%"]}
                                    activeUnit={templateHelper.getUnit(template, "interaction.agenda.row.default.text.fontSize")}
                                    steps={1}
                                    max={100}
                                    min={1}
                                    path={"interaction.agenda.row.default.row.default.text.fontSize"}
                                    label="TextFontSize"
                                />
                                <hr/>
                                <JirangoFontPicker
                                    onChange={this.handleChange}
                                    path="interaction.client.agenda.row.default.text.fontFamily"
                                    currentFontFamily={
                                        template && template.content.interaction.agenda.row.default.text.fontFamily
                                    }
                                />
                                <FontWeightPicker
                                    onChange={this.handleChange}
                                    path="interaction.client.agenda.row.default.text.fontWeight"
                                    currentFont={template.content.interaction.agenda.row.default.text.fontFamily}
                                    weight={template.content.interaction.agenda.row.default.text.fontWeight}
                                />
                            </div>
                        </ListExpansion>


                    </div>
                </ListExpansion>
                <br/>
                <ListExpansion
                    footer={false}
                    description="ActiveRowStyle"
                >
                    <div style={{ paddingTop: "10px" }}>
                        <ListExpansion
                            footer={false}
                            description="FrameStyle"
                        >
                            <div style={{ paddingTop: "10px" }}>
                                <Row>
                                    <Col><SystemLabel name="FrameBackgroundColor" /></Col>
                                    <Col className="list-setting-item-input">
                                        <ColorPickerFacade
                                            color={template.content.interaction.agenda.row.active.frame.backgroundColor}
                                            onChange={(color, e) =>
                                                this.handleChange(color, e, "interaction.agenda.row.active.frame.backgroundColor")
                                            }
                                            path="interaction.agenda.row.active.frame.backgroundColor"
                                        />
                                    </Col>
                                </Row>
                                <hr />
                                <Row>
                                    <Col><SystemLabel name="FrameBorderColor" /></Col>
                                    <Col className="list-setting-item-input">
                                        <ColorPickerFacade
                                            color={template.content.interaction.agenda.row.active.frame.borderColor}
                                            onChange={(color, e) =>
                                                this.handleChange(color, e, "interaction.agenda.row.active.frame.borderColor")
                                            }
                                            path="interaction.agenda.row.active.frame.borderColor"
                                        />
                                    </Col>
                                </Row>
                                <hr />
                                <EditorSlider
                                    value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.row.active.frame.borderWidth")}
                                    defaultValue={0}
                                    unitChange={this.handleUnitChange}
                                    onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                                    units={["px", "rem", "%"]}
                                    activeUnit={templateHelper.getUnit(template, "interaction.agenda.row.active.frame.borderWidth")}
                                    steps={1}
                                    max={100}
                                    min={1}
                                    path={"interaction.agenda.row.active.frame.borderWidth"}
                                    label="FrameBorderWidth"
                                />
                                <hr/>
                                  <EditorSlider
                                    value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.row.active.frame.borderRadius")}
                                    defaultValue={0}
                                    unitChange={this.handleUnitChange}
                                    onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                                    units={["px", "rem", "%"]}
                                    activeUnit={templateHelper.getUnit(template, "interaction.agenda.row.active.frame.borderRadius")}
                                    steps={1}
                                    max={100}
                                    min={1}
                                    path={"interaction.agenda.row.active.frame.borderRadius"}
                                    label="FrameBorderRadius"
                                />
                                <hr />
                                <EditorSlider
                                    value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.row.active.frame.padding")}
                                    defaultValue={0}
                                    unitChange={this.handleUnitChange}
                                    onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                                    units={["px", "rem", "%"]}
                                    activeUnit={templateHelper.getUnit(template, "interaction.agenda.row.active.frame.padding")}
                                    steps={1}
                                    max={100}
                                    min={1}
                                    path={"interaction.agenda.row.active.frame.padding"}
                                    label="FramePadding"
                                />
                                <hr/>
                                 <EditorSlider
                                    value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.row.active.frame.marginTop")}
                                    defaultValue={0}
                                    unitChange={this.handleUnitChange}
                                    onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                                    units={["px", "rem", "%"]}
                                    activeUnit={templateHelper.getUnit(template, "interaction.agenda.row.active.frame.marginTop")}
                                    steps={1}
                                    max={100}
                                    min={1}
                                    path={"interaction.agenda.row.active.frame.marginTop"}
                                    label="FrameMarginTop"
                                />
                            </div>
                        </ListExpansion>
                        <hr />
                        <ListExpansion
                            footer={false}
                            description="TitleStyle"
                        >
                          <div style={{ paddingTop: "10px" }}>
                                <Row>
                                    <Col><SystemLabel name="TitleColor" /></Col>
                                    <Col className="list-setting-item-input">
                                        <ColorPickerFacade
                                            color={template.content.interaction.agenda.row.active.title.color}
                                            onChange={(color, e) =>
                                                this.handleChange(color, e, "interaction.agenda.row.active.title.color")
                                            }
                                            path="interaction.agenda.row.active.title.color"
                                        />
                                    </Col>
                                </Row>
                                <hr />
                                <EditorSlider
                                    value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.row.active.title.fontSize")}
                                    defaultValue={0}
                                    unitChange={this.handleUnitChange}
                                    onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                                    units={["px", "rem", "%"]}
                                    activeUnit={templateHelper.getUnit(template, "interaction.agenda.row.active.title.fontSize")}
                                    steps={1}
                                    max={100}
                                    min={1}
                                    path={"interaction.agenda.row.default.row.active.title.fontSize"}
                                    label="TitleFontSize"
                                />
                                <hr/>
                                <JirangoFontPicker
                                    onChange={this.handleChange}
                                    path="interaction.client.agenda.row.active.title.fontFamily"
                                    currentFontFamily={
                                        template && template.content.interaction.agenda.row.active.title.fontFamily
                                    }
                                />
                                <FontWeightPicker
                                    onChange={this.handleChange}
                                    path="interaction.client.agenda.row.active.title.fontWeight"
                                    currentFont={template.content.interaction.agenda.row.active.title.fontFamily}
                                    weight={template.content.interaction.agenda.row.active.title.fontWeight}
                                />
                            </div>
                        </ListExpansion>
                        <hr />
                        <ListExpansion
                            footer={false}
                            description="TextStyle"
                        >
                            <div style={{ paddingTop: "10px" }}>
                                <Row>
                                    <Col><SystemLabel name="TextColor" /></Col>
                                    <Col className="list-setting-item-input">
                                        <ColorPickerFacade
                                            color={template.content.interaction.agenda.row.active.text.color}
                                            onChange={(color, e) =>
                                                this.handleChange(color, e, "interaction.agenda.row.active.text.color")
                                            }
                                            path="interaction.agenda.row.active.text.color"
                                        />
                                    </Col>
                                </Row>
                                <hr />
                                <EditorSlider
                                    value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.row.active.text.fontSize")}
                                    defaultValue={0}
                                    unitChange={this.handleUnitChange}
                                    onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                                    units={["px", "rem", "%"]}
                                    activeUnit={templateHelper.getUnit(template, "interaction.agenda.row.active.text.fontSize")}
                                    steps={1}
                                    max={100}
                                    min={1}
                                    path={"interaction.agenda.row.default.row.active.text.fontSize"}
                                    label="TextFontSize"
                                />
                                <hr/>
                                <JirangoFontPicker
                                    onChange={this.handleChange}
                                    path="interaction.client.agenda.row.active.text.fontFamily"
                                    currentFontFamily={
                                        template && template.content.interaction.agenda.row.active.text.fontFamily
                                    }
                                />
                                <FontWeightPicker
                                    onChange={this.handleChange}
                                    path="interaction.client.agenda.row.active.text.fontWeight"
                                    currentFont={template.content.interaction.agenda.row.active.text.fontFamily}
                                    weight={template.content.interaction.agenda.row.active.text.fontWeight}
                                />
                            </div>
                        </ListExpansion>


                    </div>
                </ListExpansion>
                <br />
                <ListExpansion
                    footer={false}
                    description="PassedRowStyle"
                >
                    <div style={{ paddingTop: "10px" }}>
                        <ListExpansion
                            footer={false}
                            description="FrameStyle"
                        >
                            <div style={{ paddingTop: "10px" }}>
                                <Row>
                                    <Col><SystemLabel name="FrameBackgroundColor" /></Col>
                                    <Col className="list-setting-item-input">
                                        <ColorPickerFacade
                                            color={template.content.interaction.agenda.row.passed.frame.backgroundColor}
                                            onChange={(color, e) =>
                                                this.handleChange(color, e, "interaction.agenda.row.passed.frame.backgroundColor")
                                            }
                                            path="interaction.agenda.row.passed.frame.backgroundColor"
                                        />
                                    </Col>
                                </Row>
                                <hr />
                                <Row>
                                    <Col><SystemLabel name="FrameBorderColor" /></Col>
                                    <Col className="list-setting-item-input">
                                        <ColorPickerFacade
                                            color={template.content.interaction.agenda.row.passed.frame.borderColor}
                                            onChange={(color, e) =>
                                                this.handleChange(color, e, "interaction.agenda.row.passed.frame.borderColor")
                                            }
                                            path="interaction.agenda.row.passed.frame.borderColor"
                                        />
                                    </Col>
                                </Row>
                                <hr />
                                <EditorSlider
                                    value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.row.passed.frame.borderWidth")}
                                    defaultValue={0}
                                    unitChange={this.handleUnitChange}
                                    onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                                    units={["px", "rem", "%"]}
                                    activeUnit={templateHelper.getUnit(template, "interaction.agenda.row.passed.frame.borderWidth")}
                                    steps={1}
                                    max={100}
                                    min={1}
                                    path={"interaction.agenda.row.passed.frame.borderWidth"}
                                    label="FrameBorderWidth"
                                />
                                <hr/>
                                  <EditorSlider
                                    value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.row.passed.frame.borderRadius")}
                                    defaultValue={0}
                                    unitChange={this.handleUnitChange}
                                    onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                                    units={["px", "rem", "%"]}
                                    activeUnit={templateHelper.getUnit(template, "interaction.agenda.row.passed.frame.borderRadius")}
                                    steps={1}
                                    max={100}
                                    min={1}
                                    path={"interaction.agenda.row.passed.frame.borderRadius"}
                                    label="FrameBorderRadius"
                                />
                                <hr />
                                <EditorSlider
                                    value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.row.passed.frame.padding")}
                                    defaultValue={0}
                                    unitChange={this.handleUnitChange}
                                    onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                                    units={["px", "rem", "%"]}
                                    activeUnit={templateHelper.getUnit(template, "interaction.agenda.row.passed.frame.padding")}
                                    steps={1}
                                    max={100}
                                    min={1}
                                    path={"interaction.agenda.row.passed.frame.padding"}
                                    label="FramePadding"
                                />
                                <hr/>
                                 <EditorSlider
                                    value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.row.passed.frame.marginTop")}
                                    defaultValue={0}
                                    unitChange={this.handleUnitChange}
                                    onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                                    units={["px", "rem", "%"]}
                                    activeUnit={templateHelper.getUnit(template, "interaction.agenda.row.passed.frame.marginTop")}
                                    steps={1}
                                    max={100}
                                    min={1}
                                    path={"interaction.agenda.row.passed.frame.marginTop"}
                                    label="FrameMarginTop"
                                />
                            </div>
                        </ListExpansion>
                        <hr />
                        <ListExpansion
                            footer={false}
                            description="TitleStyle"
                        >
                          <div style={{ paddingTop: "10px" }}>
                                <Row>
                                    <Col><SystemLabel name="TitleColor" /></Col>
                                    <Col className="list-setting-item-input">
                                        <ColorPickerFacade
                                            color={template.content.interaction.agenda.row.passed.title.color}
                                            onChange={(color, e) =>
                                                this.handleChange(color, e, "interaction.agenda.row.passed.title.color")
                                            }
                                            path="interaction.agenda.row.passed.title.color"
                                        />
                                    </Col>
                                </Row>
                                <hr />
                                <EditorSlider
                                    value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.row.passed.title.fontSize")}
                                    defaultValue={0}
                                    unitChange={this.handleUnitChange}
                                    onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                                    units={["px", "rem", "%"]}
                                    activeUnit={templateHelper.getUnit(template, "interaction.agenda.row.passed.title.fontSize")}
                                    steps={1}
                                    max={100}
                                    min={1}
                                    path={"interaction.agenda.row.default.row.passed.title.fontSize"}
                                    label="TitleFontSize"
                                />
                                <hr/>
                                <JirangoFontPicker
                                    onChange={this.handleChange}
                                    path="interaction.client.agenda.row.passed.title.fontFamily"
                                    currentFontFamily={
                                        template && template.content.interaction.agenda.row.passed.title.fontFamily
                                    }
                                />
                                <FontWeightPicker
                                    onChange={this.handleChange}
                                    path="interaction.client.agenda.row.passed.title.fontWeight"
                                    currentFont={template.content.interaction.agenda.row.passed.title.fontFamily}
                                    weight={template.content.interaction.agenda.row.passed.title.fontWeight}
                                />
                            </div>
                        </ListExpansion>
                        <hr />
                        <ListExpansion
                            footer={false}
                    
                            description="TextStyle"
                        >
                            <div style={{ paddingTop: "10px" }}>
                                <Row>
                                    <Col><SystemLabel name="TextColor" /></Col>
                                    <Col className="list-setting-item-input">
                                        <ColorPickerFacade
                                            color={template.content.interaction.agenda.row.passed.text.color}
                                            onChange={(color, e) =>
                                                this.handleChange(color, e, "interaction.agenda.row.passed.text.color")
                                            }
                                            path="interaction.agenda.row.passed.text.color"
                                        />
                                    </Col>
                                </Row>
                                <hr />
                                <EditorSlider
                                    value={templateHelper.getValueWithoutUnit(template, "interaction.agenda.row.passed.text.fontSize")}
                                    defaultValue={0}
                                    unitChange={this.handleUnitChange}
                                    onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                                    units={["px", "rem", "%"]}
                                    activeUnit={templateHelper.getUnit(template, "interaction.agenda.row.passed.text.fontSize")}
                                    steps={1}
                                    max={100}
                                    min={1}
                                    path={"interaction.agenda.row.default.row.passed.text.fontSize"}
                                    label="TextFontSize"
                                />
                                <hr/>
                                <JirangoFontPicker
                                    onChange={this.handleChange}
                                    path="interaction.client.agenda.row.passed.text.fontFamily"
                                    currentFontFamily={
                                        template && template.content.interaction.agenda.row.passed.text.fontFamily
                                    }
                                />
                                <FontWeightPicker
                                    onChange={this.handleChange}
                                    path="interaction.client.agenda.row.passed.text.fontWeight"
                                    currentFont={template.content.interaction.agenda.row.passed.text.fontFamily}
                                    weight={template.content.interaction.agenda.row.passed.text.fontWeight}
                                />
                            </div>
                        </ListExpansion>


                    </div>
                </ListExpansion>
            </div>


        );
    }
}
function mapStateToProps(state) {
    return {
        alert: state.alert,
        template: state.template.template
    };
}
export default connect(mapStateToProps)(AgendaSettings);
